module.exports = __webpack_public_path__ + "static/media/12-luca----hovercolor.2fe17581.jpg";